import { useDataSourceColumns } from "@/hooks";
import type { SelectTransformer } from "@/types/workspace";
import { TagsInput } from "@mantine/core";
import { useEffect, useState } from "react";
import { TransformerBase } from "./TransformerBase";

export function TransformerSelect({
  data,
  warning,
  error,
  onUpdate,
  index,
}: {
  data: SelectTransformer;
  warning?: string;
  error?: string;
  onUpdate?: (updatedData: SelectTransformer) => void;
  index: number;
}) {
  const [columns, setColumns] = useState<string[]>(data.item_list || []);
  const availableColumns = useDataSourceColumns(index);

  useEffect(() => {
    setColumns(data.item_list || []);
  }, [data.item_list]);

  const handleChange = (value: string[]) => {
    setColumns(value);
    if (onUpdate) {
      onUpdate({
        ...data,
        item_list: value,
      });
    }
  };

  return (
    <TransformerBase warning={warning} error={error}>
      <TagsInput
        variant="light"
        bdrs="sm"
        bg="#F1F3F4"
        placeholder="Select columns"
        data={availableColumns.length > 0 ? availableColumns : []}
        value={columns}
        onChange={handleChange}
      />
    </TransformerBase>
  );
}
